var render = function render(){var _vm=this,_c=_vm._self._c;return _c('NbButton',{attrs:{"variant":"tertiary","title":"Overpack Label","disabled":_vm.loading},on:{"click":function($event){return _vm.generateOverpackLabel()}}},[_vm._v(" "+_vm._s(_vm.loading ? _vm.$t("loading") + "..." : _vm.$t("overpacksListPage.generateLabelAndInvoice"))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }